import type { FC, ReactNode } from 'react'

interface PullQuoteProps {
    quote: string
    source: ReactNode
}

const PullQuote: FC<PullQuoteProps> = ({ quote, source }): ReactNode => {
    return (
        <figure className='relative mt-10 rounded-sm bg-gold/[0.06] px-7 py-7 shadow-soft'>
            <span aria-hidden='true' className='absolute -top-6 left-5 font-heading text-7xl leading-none text-gold/40'>
                &ldquo;
            </span>

            <blockquote>
                <p className='font-heading text-xl italic leading-snug text-parchment sm:text-2xl'>
                    {quote}
                </p>
            </blockquote>

            <figcaption className='mt-4 text-sm leading-relaxed text-parchment/60'>
                {source}
            </figcaption>
        </figure>
    )
}

export default PullQuote
